<template>
  <div class="calico-field-page">
    <div class="calico-field-container">
      <div class="calico-search-row">
        <calico-search
          v-model="text1"
          placeholder="Search"
        />
      </div>
    </div>
  </div>
</template>

<script lang="js">
import CalicoSearch from '@/components/calico/search/index.vue'
export default {
  name: 'CalicoSearchFieldPage',
  components: {
    CalicoSearch
  },
  data () {
    return {
      text1: '',
    }
  },
  watch: {
    text1 (value) {
      console.log(value)
    },
  }
}
</script>
<style lang="scss">
.calico-search-page {
  display: flex;
  justify-content: center;
  align-items: center;
  .calico-search-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 100%;
    .calico-search-row {
      @include inline-space($space-large);
      @include inset-space($space-large);
      width: 100%;
    }
  }
}
</style>
